




















import { Component, Mixins } from "vue-property-decorator";
import PlanForm from "hfox/components/plan/PlanForm.vue";
import LPPlanTip from "hfox/components/plan/LPPlanTip.vue";
import mixins from "@/mixins";
import utils from "hfox/utils";
import { BOX_ASSET_ID } from "../../constants";

@Component({
  components: {
    PlanForm,
    "lp-plan-tip": LPPlanTip
  }
})
class CreatePlan extends Mixins(mixins.page) {
  plan = {
    etf: "",
    name: "",
    funds: "",
    period: {
      frequency: "Daily",
      day: null,
      hour: 0,
      minute: Math.floor(Math.random() * 60)
    }
  };

  submitting = false;

  get title() {
    return this.$t("hfox.plan.create") as string;
  }

  get isLP() {
    return this.$route.query.type === "lp";
  }

  get etfs() {
    const etfs = this.$store.state.hfox.etfs.filter(v => {
      return v.is_lp_token === this.isLP && !v.deprecated;
    });

    return etfs.filter(v => v.asset_id !== BOX_ASSET_ID);
  }

  async handleSave() {
    this.submitting = true;
    await this.requestCreatePlan();
    this.submitting = false;
  }

  async requestCreatePlan() {
    try {
      const plan = {
        ...this.plan,
        period: utils.period.toUTCPeriod(this.plan.period)
      };
      await this.$api.hfox.requestCreatePlan(plan);
      this.$common.utils.helper.toast(this, {
        message: this.$t("hfox.plan.create.success") as string,
        color: "success"
      });
      this.toMine();
      this.$store.dispatch("hfox/loadPlans");
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  toMine() {
    this.$helper.toFusionPath(this, "hfox", { name: "index" });
  }
}
export default CreatePlan;
